"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.concat.js");

var _querystring = _interopRequireDefault(require("querystring"));

var Query = {
  /**
   * @function Query[get] - 获取url上的参数值
   * @param {string} key 参数的key
   * @param {string} [url=location.href] 页面url，默认当前url
   * @example
   * import { Query } from '@zz-biz/utils';
   * 
   * Query.get('__t');
   * // return 50
   * 
   * Query.get();
   * // { a: 1, b: 2, c: 3 }  //返回对象
   * @return {string} queryValue
   */
  get: function get() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;

    if (key) {
      var reg = new RegExp("(^|[&|\\?])".concat(key, "=([^&|#]*)([&|#]|$)"));
      var hrefs = url.split('?').splice(1);

      if (hrefs.length > 0) {
        var r = null;
        hrefs.forEach(function (v) {
          if (reg.test(v)) {
            r = "?".concat(v).match(reg);
          }
        });
        if (r !== null) return decodeURIComponent(r[2]);
        return r;
      }

      return null;
    } else {
      var _reg = /([\?&])([^\?&#]*)=([^&|#|\?]*)/g;
      var result = {};
      var matchArr = url.match(_reg) || [];
      matchArr.forEach(function (v) {
        var str = v.substring(1);

        if (str) {
          result[str.split('=')[0]] = str.split('=')[1];
        }
      });
      return result;
    }
  },

  /**
   * @function Query[add] - url上添加参数
   * @param {object | string} queryData 添加的参数，支持querystr或者obj数据
   * @param {string} [url=location.href] 页面url默认当前url
   * @example
   * import { Query } from '@zz-biz/utils';
   * 
   * Query.add({a: 1});
   * 
   * // return url?a=1
   */
  add: function add(queryData) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var urlregx = /^([^\?#]+)(\?[^#]+)?(\#[^\?]+)?(\?[^#]+)?/;

    var _ref = urlregx.exec(url) || [],
        _ref2 = (0, _slicedToArray2["default"])(_ref, 5),
        whole = _ref2[0],
        domain = _ref2[1],
        queryStr1 = _ref2[2],
        hashStr = _ref2[3],
        queryStr2 = _ref2[4];

    var query1 = {};

    if (queryStr1) {
      Object.assign(query1, _querystring["default"].parse(queryStr1.substring(1)));
    }

    if (typeof queryData === 'string') {
      query1 = _querystring["default"].parse(queryData[0] === '?' ? queryData.substring(1) : queryData);
    } else {
      Object.assign(query1, queryData);
    }

    url = domain;

    if (JSON.stringify(query1) != '{}') {
      url += "?".concat(_querystring["default"].stringify(query1));
    }

    if (hashStr) {
      url += hashStr;
    }

    if (queryStr2) {
      url += "?".concat(queryStr2);
    }

    return url;
  },

  /**
   * @function Query[remove] - 删除url上的特定参数
   * @param {array | string} queryData 删除的参数字段，支持数组和字符串
   * @param {string} [url=location.href] 页面url, 默认当前url
   * @example
   * import { Query } from '@zz-biz/utils';
   * // url?a=1&b=2&c=3
   * Query.remove('a');
   * // return url?b=2&c=3
   * 
   * Query.remove(['a', 'b']);
   * // return url?c=3
   */
  remove: function remove(queryData) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;

    try {
      var reg = new RegExp("([&\\?#])(".concat(queryData instanceof Array ? queryData.join('|') : queryData, ")=([^&#]*)(?=[&#\\?]?)"), 'g');
      var matchArr = url.match(reg);

      if (matchArr && matchArr.length) {
        for (var i = 0; i < matchArr.length; i++) {
          url = url.replace(matchArr[i], matchArr[i].charAt(0) === '?' ? '?' : '');
        }
      }

      url = url.replace(/\?&+/, '?');
      return url;
    } catch (err) {
      console.warn(err);
      return url;
    }
  },

  /**
   * @function Query[getParams] - 拼接对象成为url参数字符串形式
   * @param {object} [params={}] 参数对象
   * @example
   * import { Query } from '@zz-biz/utils';
   * // url?a=1&b=2
   * Query.getParams({a: 1, b: 2, c: 3});
   * 
   * // return a=1&b=2&c=3
   */
  getParams: function getParams() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(params).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join('&');
  }
};
var _default = Query;
exports["default"] = _default;